import Vue from 'vue';
import currency from '@/extensions/filters/currency';
import date from '@/extensions/filters/date';
import filesize from '@/extensions/filters/file-size';
import length from '@/extensions/filters/length';

Vue.filter('currency', currency);
Vue.filter('date', date);
Vue.filter('filesize', filesize);
Vue.filter('length', length);
